window.customElements.define(
  'p-not-found',
  class extends HTMLElement {
    connectedCallback() {
      this.innerHTML = '<div style="padding: 1rem;"><h1>Not found</h1></div>';
    }
  },
);
